import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal, MaskLineInView } from "../components/motion/Reveal";
import { CTAButton } from "../components/ui-regera/CTAButton";
import { useArticle } from "../lib/hooks";

export default function InsightDetail() {
  const { slug } = useParams();
  const { data: a, isLoading, isError } = useArticle(slug);

  useEffect(() => {
    if (a) document.title = `${a.title} — REGERA Insights`;
  }, [a]);

  if (isLoading) return <div className="pt-40 pb-40 text-center text-white/40">Loading article…</div>;
  if (isError || !a)
    return (
      <div className="pt-40 pb-40 text-center">
        <p className="text-white/60 mb-6">Article not found.</p>
        <CTAButton to="/insights" variant="ghost">BACK TO INSIGHTS</CTAButton>
      </div>
    );

  return (
    <div data-testid="insight-detail-page">
      <article className="pt-36 lg:pt-48 pb-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Link
            to="/insights"
            data-testid="back-to-insights"
            className="inline-flex items-center gap-2 text-xs tracking-[0.16em] text-white/50 hover:text-[#e60000] transition-colors mb-8"
          >
            <ArrowLeft className="h-4 w-4" /> ALL INSIGHTS
          </Link>

          <div className="flex items-center gap-4 mb-6">
            <span className="bg-[#e60000] text-white text-[10px] tracking-[0.16em] px-3 py-1.5 uppercase">
              {a.category}
            </span>
            <span className="text-xs text-white/40">{a.read_time}</span>
          </div>

          <h1 className="font-display font-black tracking-tightest leading-[0.98] text-4xl sm:text-5xl lg:text-6xl text-white">
            <MaskLineInView>{a.title}</MaskLineInView>
          </h1>

          <Reveal delay={0.15}>
            <p className="mt-6 text-white/60 text-sm">By {a.author}</p>
            <div className="mt-10 h-px w-full bg-white/10" />
            <div className="mt-10 space-y-6">
              {a.body.split("\n\n").map((para, i) => (
                <p key={i} className="text-regera-dim text-lg leading-relaxed whitespace-pre-wrap">
                  {para}
                </p>
              ))}
            </div>
          </Reveal>

          <div className="mt-16 border-t border-white/10 pt-10">
            <CTAButton to="/contact#enquiry" testId="insight-engage-cta">ENGAGE REGERA</CTAButton>
          </div>
        </div>
      </article>
    </div>
  );
}
